import * as TypeGraphQL from "type-graphql";
export var VerificationTokenScalarFieldEnum;
(function (VerificationTokenScalarFieldEnum) {
    VerificationTokenScalarFieldEnum["id"] = "id";
    VerificationTokenScalarFieldEnum["identifier"] = "identifier";
    VerificationTokenScalarFieldEnum["token"] = "token";
    VerificationTokenScalarFieldEnum["expires"] = "expires";
})(VerificationTokenScalarFieldEnum || (VerificationTokenScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(VerificationTokenScalarFieldEnum, {
    name: "VerificationTokenScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=VerificationTokenScalarFieldEnum.js.map